import _ from "lodash"
import $ from "jquery"
import store from "redux/store"
import * as pushActions from "redux/ducks/Push"

interface nodeDistClient {
  registersAndUnregisters: Function
  getAggregated: Function
  clearAggregated: Function
  isConnect: Function
  unregistersAll: Function
}

export let nodeDistClientList: { [key: string]: nodeDistClient } = {}
let pushRegisterTimer: NodeJS.Timeout | null = null

const PUSH_INTERVAL = 500

/**
 * 登録名
 * @param {*} name
 * NodeDistの接続先追加
 * @param nodeDistClient 接続先URL
 */
export function addNodeDist(name: string, nodeDistClient: nodeDistClient) {
  if (!_.has(nodeDistClientList, name)) {
    nodeDistClientList[name] = nodeDistClient
  }
}

/**
 * 各コンポーネントが更新された時、Symbolリストを取得し、レジスト / アンレジストを行う
 */
export function pushSymbolList() {
  if (pushRegisterTimer) {
    return
  }

  pushRegisterTimer = setTimeout(() => {
    // bodyの中で判定しないとモーダル系が対象に含まれない
    const targets = $("body [data-push=true]").map((index, elem) =>
      elem.getAttribute("data-symbol")
    )

    _.forEach(nodeDistClientList, nodeDistClient => {
      nodeDistClient.registersAndUnregisters(_.uniq(targets))
    })

    pushRegisterTimer = null
  }, PUSH_INTERVAL)
}

export function unregisterAll() {
  const targets = $("body [data-push=true]").map((index, elem) =>
    elem.getAttribute("data-symbol")
  )
  _.forEach(nodeDistClientList, nodeDistClient => {
    nodeDistClient.unregistersAll(_.uniq(targets))
  })
}

class NodeDistActionTimer {
  _actions: { [key: string]: Function }
  constructor() {
    this._actions = {}
    setInterval(() => {
      Object.keys(this._actions).map(async key => {
        const next = await this._actions[key]()
        if (!next) {
          delete this._actions[key]
        }
      })
    }, PUSH_INTERVAL)
  }

  add = (key: string, action: Function) => {
    this._actions[key] = action
  }
}

//フル板と銘柄Pushで共通のsetIntervalを使う
export const nodeDistActionTimer = new NodeDistActionTimer()

// 受けたまんまを流すとActionが発行されまくって(特にreg/unregで切り替える瞬間)パフォーマンスに影響があるので、
// 一定間隔で来たメッセージを一纏めにする
// そのため各クライアントで更新処理をしてしまうとタイミングがズレてしまうのでマネージャーで更新処理をする
const nodeDistClientBaseIntervalFunc = async () => {
  // reduceを使うべき？
  // 格納するパラメーター
  //updatePushFromSocketの中で直接にaggregatedを変えています。
  let aggregated = {}
  _.forEach(nodeDistClientList, nodeDistClient => {
    _.merge(aggregated, nodeDistClient.getAggregated())
    nodeDistClient.clearAggregated()
  })

  // Push用のActionを作成して、msgを飛ばす
  if (Object.keys(aggregated).length !== 0) {
    store.dispatch<any>(
      pushActions.updatePushFromSocket({
        data: aggregated,
      })
    )
  }
  // console.log("aggregated", _.get(aggregated, ["*@E@8411@T", "Price"]))
  return true
}

//即時関数だとintervalが終わるまでメモリーを解消しないので、外に置くことでガベージコレクタが正常にメモリーを解除できます。
nodeDistActionTimer.add("nodeDistClientBase", nodeDistClientBaseIntervalFunc)
